<div class="layout-topbar">
	<div *ngIf="appMain.isMobile()" class="layout-topbar-logo">
		<div class="layout-topbar-logo mr-3">
			<img src="assets/img/logo_white.png" alt="logo" style="max-width: 160px" />
		</div>
	</div>

	<div class="layout-menu-button layout-topbar-button">
		<div *ngIf="appMain.isDesktop()" class="layout-topbar-logo mr-3">
			<div
				style="
					font-family: Albert Sans Regular;
					font-size: 15px;
					color: black;
					transition: background-color 0.3s ease;
				"
				class="mr-1 text-center"
			></div>
		</div>
		<i class="pi pi-bars" href="#" (click)="appMain.toggleMenu($event)"></i>
	</div>

	<div
		class="p-link layout-topbar-menu-button layout-topbar-button"
		(click)="appMain.toggleTopMenu($event)"
	>
		<i class="pi pi-ellipsis-v"></i>
	</div>

	<!-- Parte centrar en escritorio -->
	<div
		*ngIf="appMain.isDesktop()"
		class="w-full flex justify-content-center aling-items-center"
	>
		<a *ngIf="appMain.isDesktop()" class="layout-topbar-logo mr-3">
			<img src="assets/img/logo_white.png" alt="logo" style="max-width: 160px" />
		</a>
	</div>

	<div
		class="layout-topbar-menu text-center border-round bg-secondary pl-2"
		[ngClass]="{ 'layout-topbar-menu-mobile-active': appMain.topMenuActive }"
	>
		<div
			class="code"
		    *ngIf="getUser() && getUser().role_id > 1"
		>
		Código <h2>{{getUser().community.code}}</h2>
		</div>
		&nbsp; 
		<button 
			pButton
			pRipple
			type="button"
			label="Cerrar sesión"
			icon="pi pi-sign-out"
			iconPos="right"
			class="p-button-rounded"
			(click)="logout()"
		></button>
	</div>
</div>


<p-dialog
	header="Eliminación de cuenta"
	[(visible)]="confirmDeleteDialog"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '30vw' }"
>
	<div class="grid p-fluid mt-3">
		<div class="form-container">
			<div class="field col-12">
				¿Estás seguro de eliminar tu cuenta?. Todos los datos relacionados con tu perfil se eliminaran.
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<p-button
			styleClass="p-button-rounded p-button-cancel mt-4"
			label="Cancelar"
			(click)="deleteAccountCancel()"
			[loading]="loading"
		>
		</p-button>
		<p-button
			severity="danger"
			styleClass="p-button-rounded mt-4"
			label="Aceptar"
			(click)="deleteAccountConfirm()"
			[loading]="loading"
		>
		</p-button>
	</ng-template>
</p-dialog>
